import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import PublicNav from "@/components/layout/PublicNav";
import PublicFooter from "@/components/layout/PublicFooter";

export default function PublicShell({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-white text-foreground">
      <PublicNav />
      <main className="flex-1">{children}</main>
      <PublicFooter />
    </div>
  );
}

export function useSiteContent() {
  const [content, setContent] = useState(null);
  useEffect(() => {
    let active = true;
    api
      .get("/content")
      .then((r) => {
        if (active) setContent(r.data?.content || {});
      })
      .catch(() => {
        if (active) setContent({});
      });
    return () => {
      active = false;
    };
  }, []);
  return content;
}
